import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {UserRequest} from "../../model/UserRequest";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class PartialRequestFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(ur: UserRequest): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<string>({
        key: "rejectReason",
        label: 'Merci de préciser le motif du rejet partiel de la demande',
        type: 'textarea',
        value: '',
        required: true,
        warn: 'Attention, celui-ci apparaitra dans le mail de retour du client.',
        order: 1
      })
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }
}
